document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-cart-quantity]').forEach(control=>{
    const input=control.querySelector('input');
    control.querySelector('[data-cart-minus]')?.addEventListener('click',()=>{input.value=Math.max(0,(+input.value||0)-1);input.form?.requestSubmit();});
    control.querySelector('[data-cart-plus]')?.addEventListener('click',()=>{input.value=(+input.value||0)+1;input.form?.requestSubmit();});
  });

  const root=document.querySelector('[data-product-root]');
  if(!root)return;
  const dataEl=root.querySelector('[data-product-json]');
  if(!dataEl)return;
  const data=JSON.parse(dataEl.textContent);
  const styleIndex=data.options.indexOf('Style');
  const sizeIndex=data.options.indexOf('Size');
  const garmentWrap=root.querySelector('[data-garment-options]');
  const colorWrap=root.querySelector('[data-color-options]');
  const sizeWrap=root.querySelector('[data-size-options]');
  const idInput=root.querySelector('[data-variant-id]');
  const priceEl=root.querySelector('[data-product-price]');
  const mainImage=root.querySelector('[data-main-product-image]');
  const dialog=root.querySelector('[data-size-dialog]');
  const uniq=values=>[...new Set(values.filter(Boolean))];
  const availableVariants=data.variants.filter(variant=>variant.available);
  const variantById=id=>data.variants.find(variant=>String(variant.id)===String(id));
  const urlVariant=()=>new URL(window.location.href).searchParams.get('variant');
  const initialVariant=variantById(urlVariant())||variantById(data.selectedVariantId)||availableVariants[0]||data.variants[0];
  let selectedStyle=styleIndex>=0?initialVariant?.options[styleIndex]:null;
  let selectedSize=sizeIndex>=0?initialVariant?.options[sizeIndex]:null;
  let selectedGroup='';

  function styleParts(style){
    const value=String(style||'').trim();
    let match=value.match(/^(.*?)\s+(Adult|Youth|Toddler)\s+(.+)$/i);
    if(match){
      const color=match[1].trim()||value;
      const audience=match[2].toLowerCase();
      const garment=match[3].replace(/\s+/g,' ').trim();
      let group=`${match[2]} ${garment}`.replace(/T\s*Shirt/i,'T-Shirt');
      if(audience==='adult'&&/hoodie/i.test(garment))group='Hoodie';
      return{group,color,style:value};
    }
    match=value.match(/^(.*?)\s+(Hoodie|T[- ]?Shirt|Tee|Sweatshirt|Tank(?: Top)?)$/i);
    if(match)return{group:match[2].replace(/T[- ]?Shirt/i,'T-Shirt'),color:match[1].trim()||value,style:value};
    return{group:'Style',color:value,style:value};
  }

  const styleEntries=styleIndex<0?[]:uniq(availableVariants.map(variant=>variant.options[styleIndex])).map(styleParts);
  const entryForStyle=style=>styleEntries.find(entry=>entry.style===style);
  const entriesForGroup=group=>styleEntries.filter(entry=>entry.group===group);
  const variantsForStyle=()=>availableVariants.filter(variant=>styleIndex<0||variant.options[styleIndex]===selectedStyle);
  const sizesForStyle=()=>sizeIndex<0?[]:uniq(variantsForStyle().map(variant=>variant.options[sizeIndex]));
  const money=cents=>new Intl.NumberFormat(undefined,{style:'currency',currency:data.currency||'USD'}).format(cents/100);

  function setSelectedFromVariant(variant){
    if(!variant)return;
    selectedStyle=styleIndex>=0?variant.options[styleIndex]:null;
    selectedSize=sizeIndex>=0?variant.options[sizeIndex]:null;
    selectedGroup=entryForStyle(selectedStyle)?.group||'';
  }

  function currentVariant(){
    return availableVariants.find(variant=>(styleIndex<0||variant.options[styleIndex]===selectedStyle)&&(sizeIndex<0||variant.options[sizeIndex]===selectedSize))||variantsForStyle()[0]||availableVariants[0];
  }

  function applyVariant({updateUrl=true}={}){
    const variant=currentVariant();
    if(!variant)return;
    idInput.value=String(variant.id);
    idInput.setAttribute('value',String(variant.id));
    idInput.dispatchEvent(new Event('change',{bubbles:true}));
    if(priceEl)priceEl.textContent=money(variant.price);
    renderVariantImage(variant);
    if(dialog?.open)renderAllCharts();
    if(updateUrl){
      const url=new URL(window.location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({variantId:variant.id},'',url);
    }
  }

  function button(label,className,selected,onClick){
    const element=document.createElement('button');
    element.type='button';
    element.className=className+(selected?' is-selected':'');
    element.textContent=label;
    element.setAttribute('aria-pressed',selected?'true':'false');
    element.addEventListener('click',onClick);
    return element;
  }

  function renderGarments(){
    if(!garmentWrap||styleIndex<0)return;
    const groups=uniq(styleEntries.map(entry=>entry.group));
    if(!groups.includes(selectedGroup))selectedGroup=entryForStyle(selectedStyle)?.group||groups[0]||'';
    garmentWrap.innerHTML='';
    groups.forEach(group=>garmentWrap.appendChild(button(group,'cd-option-btn cd-garment-btn',group===selectedGroup,()=>{
      selectedGroup=group;
      const first=entriesForGroup(group)[0];
      selectedStyle=first?.style||selectedStyle;
      selectedSize=sizesForStyle()[0]||null;
      renderGarments();renderColors();renderSizes();applyVariant();
    })));
  }

  function renderColors(){
    if(!colorWrap||styleIndex<0)return;
    colorWrap.innerHTML='';
    entriesForGroup(selectedGroup).forEach(entry=>colorWrap.appendChild(button(entry.color,'cd-option-btn cd-color-btn',entry.style===selectedStyle,()=>{
      selectedStyle=entry.style;
      selectedSize=sizesForStyle().includes(selectedSize)?selectedSize:(sizesForStyle()[0]||null);
      renderColors();renderSizes();applyVariant();
    })));
  }

  function renderSizes(){
    if(!sizeWrap||sizeIndex<0)return;
    const sizes=sizesForStyle();
    if(!sizes.includes(selectedSize))selectedSize=sizes[0]||null;
    sizeWrap.innerHTML='';
    sizes.forEach(size=>sizeWrap.appendChild(button(size.replace(/^Adult\s+/i,'').replace(/^Youth\s+/i,''),'cd-option-btn cd-size-btn',size===selectedSize,()=>{
      selectedSize=size;renderSizes();applyVariant();
    })));
  }

  const mediaId=value=>String(value??'').split('/').pop();
  const media=new Map((data.media||[]).map(item=>[mediaId(item.id),item]));
  const manifest=data.mediaManifest;
  const hasManifest=manifest?.schema_version===1&&Array.isArray(manifest.images)&&manifest.styles&&typeof manifest.styles==='object';
  const hasManifestValue=manifest!==null&&manifest!==undefined;
  const manifestStyles=hasManifest?Object.entries(manifest.styles):[];
  const manifestImages=hasManifest?manifest.images:[];
  const actualStyles=new Set(data.variants.map(v=>v.options[styleIndex]));
  const styleMetadata=style=>{
    const matches=manifestStyles.filter(([,entry])=>entry.label===style);
    return matches.length===1?matches[0]:null;
  };
  function mappedMedia(style,kind){
    const pair=styleMetadata(style);
    if(!pair)return null;
    const [key,entry]=pair;
    const id=mediaId(kind==='mockup'?entry.mockup_media_id:entry.chart_media_id);
    if(!id)return null;
    const matches=manifestImages.filter(im=>mediaId(im.media_id)===id&&im.kind===kind&&im.applies_to?.includes(key));
    if(matches.length!==1)return null;
    if(kind==='size_chart'&&String(matches[0].garment_id)!==String(entry.garment_id))return null;
    return media.get(id)||null;
  }
  function legacyChart(style){
    const matches=[...media.values()].filter(im=>{
      const alt=String(im.alt||'');
      const labels=alt.includes('size chart:')?alt.split('size chart:').pop().trim():alt;
      return labels.split(' + ').some(label=>label===style||label.endsWith(' '+style));
    });
    return matches.length===1?matches[0]:null;
  }
  function imageForVariant(variant){
    const style=variant.options[styleIndex];
    if(hasManifestValue)return mappedMedia(style,'mockup');
    const image=media.get(mediaId(variant.mediaId));
    if(!image||legacyChart(style)?.id===image.id)return null;
    const parts=styleParts(style);
    if(/hoodie/i.test(parts.group)&&!/hoodie/i.test(image.alt||''))return null;
    return image;
  }
  const imagePlaceholder=root.querySelector('[data-image-placeholder]');
  const thumbWrap=root.querySelector('[data-product-thumbs]');
  function showImage(image){
    if(mainImage){
      mainImage.hidden=!image;
      if(image){mainImage.src=image.src;mainImage.alt=image.alt||selectedStyle;mainImage.width=image.width;mainImage.height=image.height;}
      else{mainImage.removeAttribute('src');mainImage.alt='';}
    }
    if(imagePlaceholder)imagePlaceholder.hidden=Boolean(image);
  }
  function renderVariantImage(variant){
    const image=imageForVariant(variant);
    showImage(image);
    if(!thumbWrap)return;
    thumbWrap.replaceChildren();
    if(!image)return;
    const style=variant.options[styleIndex],pair=styleMetadata(style);
    const candidates=hasManifest?manifestImages.filter(im=>im.kind==='mockup').map(im=>media.get(mediaId(im.media_id))).filter(Boolean):data.variants.map(imageForVariant).filter(Boolean);
    const seen=new Set();
    candidates.forEach(item=>{
      if(seen.has(item.id))return;seen.add(item.id);
      const control=button(item.alt||style,'cd-media-thumb',item.id===image.id,()=>{
        showImage(item);
        thumbWrap.querySelectorAll('button').forEach(b=>{const active=b===control;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active));});
      });
      control.textContent='';control.classList.toggle('is-active',item.id===image.id);control.setAttribute('aria-label',item.alt||style);
      const img=document.createElement('img');img.src=item.src;img.alt=item.alt||style;img.width=item.width;img.height=item.height;
      control.appendChild(img);thumbWrap.appendChild(control);
    });
  }
  function renderAllCharts(){
    const wrap=root.querySelector('[data-size-guide-all]');
    if(!wrap)return;
    const charts=new Map();
    actualStyles.forEach(style=>{
      const image=hasManifestValue?mappedMedia(style,'size_chart'):legacyChart(style);
      if(!image)return;
      if(!charts.has(image.id))charts.set(image.id,{image,labels:[]});
      charts.get(image.id).labels.push(style);
    });
    const selectedImage=hasManifestValue?mappedMedia(selectedStyle,'size_chart'):legacyChart(selectedStyle);
    const entries=[...charts.values()].sort((a,b)=>Number(b.image.id===selectedImage?.id)-Number(a.image.id===selectedImage?.id)||a.labels.join().localeCompare(b.labels.join()));
    wrap.replaceChildren();
    if(!selectedImage){const note=document.createElement('p');note.className='cd-no-charts';note.textContent=data.messages.chartUnavailable;wrap.appendChild(note);}
    entries.forEach(({image,labels})=>{
      const card=document.createElement('section');card.className='cd-size-chart-card'+(image.id===selectedImage?.id?' is-current':'');card.dataset.chartMediaId=String(image.id);
      const head=document.createElement('div');head.className='cd-size-chart-head';
      const title=document.createElement('h3');title.textContent=labels.join(' + ');head.appendChild(title);
      if(image.id===selectedImage?.id){const badge=document.createElement('span');badge.textContent=data.messages.selectedStyle;head.appendChild(badge);}
      const img=document.createElement('img');img.src=image.src;img.alt=image.alt||labels.join(' + ');img.width=image.width;img.height=image.height;img.loading='lazy';
      card.appendChild(head);card.appendChild(img);wrap.appendChild(card);
    });
  }

  root.querySelectorAll('[data-open-size-guide]').forEach(control=>control.addEventListener('click',event=>{event.preventDefault();renderAllCharts();dialog?.showModal();}));
  root.querySelectorAll('[data-close-size-guide]').forEach(control=>control.addEventListener('click',()=>dialog?.close()));
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  const quantity=root.querySelector('[data-qty]');
  root.querySelector('[data-qty-minus]')?.addEventListener('click',()=>quantity.value=Math.max(1,(+quantity.value||1)-1));
  root.querySelector('[data-qty-plus]')?.addEventListener('click',()=>quantity.value=(+quantity.value||1)+1);
  idInput.form?.addEventListener('submit',()=>{
    const variant=currentVariant();
    if(variant){idInput.value=String(variant.id);idInput.setAttribute('value',String(variant.id));}
  });
  window.addEventListener('popstate',()=>{
    const variant=variantById(urlVariant());
    if(!variant)return;
    setSelectedFromVariant(variant);renderGarments();renderColors();renderSizes();applyVariant({updateUrl:false});
  });
  setSelectedFromVariant(initialVariant);renderGarments();renderColors();renderSizes();applyVariant({updateUrl:!urlVariant()});
});


// Natural shoe ordering; theme typography is intentionally unchanged.
(()=>{const compare=new Intl.Collator('en',{numeric:true,sensitivity:'base'}),label=e=>(e.querySelector(':scope > a,:scope > summary')||e).textContent.trim();function sort(parent,selector){if(!parent)return;const entries=[...parent.children].filter(e=>e.matches(selector));if(!entries.length)return;const marker=document.createComment('shoe ordering');parent.insertBefore(marker,entries[0]);entries.sort((a,b)=>compare.compare(label(a),label(b))).forEach(e=>parent.insertBefore(e,marker));marker.remove();}function run(){document.querySelectorAll('.cd-shop-drop,.cd-shop-colorway').forEach(e=>sort(e,'*'));document.querySelectorAll('.cd-mobile-brand,.cd-mobile-model').forEach(e=>sort(e,'details,a'));document.querySelectorAll('.cd-links').forEach(e=>sort(e,'.cd-shop-nav'));document.querySelectorAll('.cd-mobile-panel').forEach(e=>sort(e,'.cd-mobile-brand'));}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();document.addEventListener('shopify:section:load',run);})();


